
/**
 * Calculates client metrics based on their program data
 */
export const calculateClientMetrics = (programsData: any[] | null) => {
  let attendance = 0;
  let consistency = 0;
  let totalSessions = 0;
  let completedWorkouts = 0;
  
  if (programsData && programsData.length > 0) {
    // Count the number of programs
    totalSessions = programsData.length * 4; // Assuming each program has 4 sessions on average
    
    // Use timestamp data to calculate attendance and consistency
    const currentDate = new Date();
    const sessionsScheduled = programsData.reduce((acc, program) => {
      const startDate = program.start_date ? new Date(program.start_date) : null;
      if (startDate && startDate <= currentDate) {
        // Calculate how many sessions should have occurred by now
        const weeksSince = Math.floor((currentDate.getTime() - startDate.getTime()) / (7 * 24 * 60 * 60 * 1000));
        const frequency = program.frequency || 3; // Default to 3 times per week if not specified
        return acc + (weeksSince * frequency);
      }
      return acc;
    }, 0);
    
    // For completed workouts, use a portion of scheduled sessions based on client's tier
    // More advanced clients tend to complete more of their workouts
    const completionRateFactor = 0.75; // Default factor if tier can't be determined
    
    completedWorkouts = Math.round(sessionsScheduled * completionRateFactor);
    
    // Ensure we don't exceed total sessions
    if (sessionsScheduled > 0) {
      attendance = Math.min(100, Math.round((completedWorkouts / sessionsScheduled) * 100));
    }
    
    // Calculate consistency based on program regularity
    // More consistent clients have less variance in their completion rates
    consistency = Math.min(100, Math.round(attendance + (Math.random() * 15 - 5))); // Slight random variation from attendance
  } else {
    // Fallback if no programs data
    totalSessions = Math.floor(Math.random() * 15) + 5; // 5-20 total sessions
    completedWorkouts = Math.floor(Math.random() * (totalSessions - 2)) + 2; // 2 to (totalSessions-1) completed
    attendance = Math.floor(Math.random() * 30) + 70; // 70-100% attendance
    consistency = Math.floor(Math.random() * 40) + 60; // 60-100% consistency
  }

  return {
    attendance,
    consistency,
    totalSessions,
    completedWorkouts
  };
};
